import { useEffect } from 'react';

import QueryProvider from './providers/QueryProvider';
import AppRouter from './router';
import CookieConsent from '@/components/CookieConsent/CookieConsent';
import OfflineBanner from '@/components/OfflineBanner';
import { BackendStatusProvider } from '@/contexts/BackendStatusContext';
import { Toaster } from 'react-hot-toast';
import DebugAuthButtons from '@/features/auth/ui/DebugAuthButtons';
import { captureFirstTouchIfNew } from '@/lib/analytics/entryChannel';

export default function App() {
  // Card n447gxvy — OBS F1.1. Capturamos el entry_channel + UTMs UNA
  // sola vez, al primer landing. Es idempotente: si ya hay un registro
  // en localStorage no lo sobreescribe.
  useEffect(() => {
    captureFirstTouchIfNew();
  }, []);

  return (
    <BackendStatusProvider>
      <QueryProvider>
        <OfflineBanner />
        {import.meta.env.MODE !== 'production' && <DebugAuthButtons />}
        <AppRouter />
        <Toaster position="top-right" />
        {/* CookieConsent va al final del árbol para renderizar fijo al bottom
            en todas las rutas. Card 71tCkSkN — OBS F0.5. */}
        <CookieConsent />
      </QueryProvider>
    </BackendStatusProvider>
  );
}
